import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const DeleteWorkflowMutation = graphql(`
  mutation DeleteWorkflow($id: ID!) {
    deleteWorkflow(id: $id)
  }
`);

export function useDeleteWorkflow() {
  const [result, deleteWorkflowMutation] = useMutation(DeleteWorkflowMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteWorkflow = useCallback(
    async (id: string) => {
      try {
        const response = await deleteWorkflowMutation({ id });
        if (response.error) {
          throw response.error;
        }

        return response.data?.deleteWorkflow ?? false;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to delete workflow");
        setError(error);

        console.error("unable to delete workflow", error);

        return false;
      }
    },
    [deleteWorkflowMutation],
  );

  return { deleteWorkflow, isPending: result.fetching, error };
}
